import { IconButton } from "@mui/material";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import React from "react";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import BootstrapModal from "react-bootstrap/Modal";
import PermissionComponent, {
  getPermissionDisplayName,
} from "../../../Shared/Common/Permissions/PermissionComponent";
import { AddIcon, LoaderIcon, RemoveICon } from "../../../Shared/Icons";
import useLang from "Shared/hooks/useLanguage";

function ReportDisclaimerRow({
  item,
  Edit,
  check,
  setOpen,
  handleClose,
  statusChange,
  disableDeletebutton,
  DeleteReportDisclaimerById,
}: any) {

  const { t } = useLang();
  const [open1, setOpen1] = React.useState(false);
  const [openalert, setOpenAlert] = React.useState(false);
  const handleCloseAlert = () => {
    setOpenAlert(false);
  };
  const handleClickOpen = () => {
    setOpenAlert(true);
  };

  return (
    <>
      <TableRow>
        <TableCell className="text-center">
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen1(!open1)}
            className="btn btn-icon btn-icon-light btn-sm fw-bold btn-table-expend-row rounded h-20px w-20px"
          >
            {open1 ? (
              <button
                id={`ReportDisclaimerCloseExpand_${item.id}`}
                className="btn btn-icon btn-icon-light btn-sm fw-bold rounded h-10px w-20px"
              >
                <RemoveICon />
              </button>
            ) : (
              <button
                id={`ReportDisclaimerOpenExpand_${item.id}`}
                className="btn btn-icon btn-icon-light btn-sm fw-bold btn-primary rounded h-20px w-20px min-h-20px"
              >
                <AddIcon />
              </button>
            )}
          </IconButton>
        </TableCell>
        <TableCell className="text-center">
          <div className="rotatebtnn">
            <DropdownButton
              className="p-0 del-before btn btn-light-info btn-active-info btn-sm btn-action table-action-btn"
              key="end"
              id={`ReportDisclaimer3Dots_${item.id}`}
              drop="end"
              title={<i className="bi bi-three-dots-vertical p-0"></i>}
            >
              {item?.isActive === true ? (
                <>
                  <PermissionComponent
                    moduleName="Setup"
                    pageName="Report Disclaimer"
                    permissionIdentifier="Edit"
                  >
                    {({
                      pageName,
                      moduleName,
                      permissionIdentifier,
                    }) => (
                      <Dropdown.Item
                        id={`ReportDisclaimerEdit`}
                        className="w-auto"
                        eventKey="1"
                        onClick={() => {
                          Edit(item);
                          handleClose();
                          setOpen(false);
                        }}
                      >
                        <div className="menu-item px-3">
                          <i className="fa fa-edit text-warning mr-2 w-20px"></i>
                          {getPermissionDisplayName(
                            pageName,
                            moduleName,
                            permissionIdentifier,
                            t("Edit")
                          )}
                        </div>
                      </Dropdown.Item>
                    )}
                  </PermissionComponent>
                  <PermissionComponent
                    moduleName="Setup"
                    pageName="Report Disclaimer"
                    permissionIdentifier="Delete"
                  >
                    {({
                      pageName,
                      moduleName,
                      permissionIdentifier,
                    }) => (
                      <Dropdown.Item
                        id={`ReportDisclaimerDelete`}
                        eventKey="2"
                        onClick={handleClickOpen}
                        className="w-auto"
                      >
                        <div className="menu-item px-3">
                          <i className="fa fa-trash text-danger mr-2 w-20px"></i>
                          {getPermissionDisplayName(
                            pageName,
                            moduleName,
                            permissionIdentifier,
                            t("Delete")
                          )}
                        </div>
                      </Dropdown.Item>
                    )}
                  </PermissionComponent>
                  <PermissionComponent
                    moduleName="Setup"
                    pageName="Report Disclaimer"
                    permissionIdentifier="Inactive"
                  >
                    {({
                      pageName,
                      moduleName,
                      permissionIdentifier,
                    }) => (
                      <Dropdown.Item
                        id={`ReportDisclaimerInactive`}
                        className="w-auto"
                        onClick={() => {
                          statusChange(item?.id, false);
                        }}
                        eventKey="3"
                      >
                        <div className="menu-item px-3">
                          <i className="fa fa-ban text-danger mr-2 w-20px"></i>
                          {getPermissionDisplayName(
                            pageName,
                            moduleName,
                            permissionIdentifier,
                            t("InActive")
                          )}
                        </div>
                      </Dropdown.Item>
                    )}
                  </PermissionComponent>
                </>
              ) : (
                <PermissionComponent
                  moduleName="Setup"
                  pageName="Report Disclaimer"
                  permissionIdentifier="Active"
                >
                  {({ pageName, moduleName, permissionIdentifier }) => (
                    <Dropdown.Item
                      id={`ReportDisclaimerActive`}
                      onClick={() => {
                        statusChange(item?.id, true);
                      }}
                      className="w-auto"
                      eventKey="3"
                    >
                      <span className="mr-2 ">
                        <i className="fa fa-circle-check text-success mr-2 w-20px"></i>
                        {getPermissionDisplayName(
                          pageName,
                          moduleName,
                          permissionIdentifier,
                          t("Active")
                        )}
                      </span>
                    </Dropdown.Item>
                  )}
                </PermissionComponent>
              )}
            </DropdownButton>
          </div>
        </TableCell>
        <TableCell id={`ReportDisclaimerRequisitionType_${item.id}`}>
          {item?.reqTypeName}
        </TableCell>
        <TableCell id={`ReportDisclaimerPaneName_${item.id}`}>
          {item?.panelName}
        </TableCell>
        <TableCell
          id={`ReportDisclaimerStatus_${item.id}`}
          className="text-center"
        >
          {item?.isActive ? (
            <i className="fa fa-circle-check text-success mr-2 w-20px"></i>
          ) : (
            <i className="fa fa-ban text-danger mr-2 w-20px"></i>
          )}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell colSpan={7} className="padding-0">
          <Collapse in={open1} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography gutterBottom component="div">
                <>
                  <div className="row">
                    <div className="col-lg-12 bg-white table-expend-sticky">
                      <div className="card shadow-sm rounded border border-warning mt-3">
                        <div className="card-header d-flex justify-content-between align-items-center bg-light-secondary min-h-35px">
                          <h6 className="mb-0">{t("Disclaimer")}</h6>
                        </div>
                        <div className="card-body py-md-4 py-3">
                          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 ">
                            <div className="row mt-3">
                              <div
                                id={`ReportDisclaimer_${item.id}`}
                                className="col-12 "
                              >
                                {item?.disclaimer}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              </Typography>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
      <BootstrapModal
        show={openalert}
        onHide={handleCloseAlert}
        backdrop="static"
        keyboard={false}
      >
        <BootstrapModal.Header closeButton className="bg-light-primary m-0 p-5">
          <h4>{t("Delete Menu")}</h4>
        </BootstrapModal.Header>
        <BootstrapModal.Body>
          {t("Are you sure you want to delete ?")}
        </BootstrapModal.Body>
        <BootstrapModal.Footer className="p-0">
          <button
            id={`ReportDisclaimerDeleteModalCancel`}
            type="button"
            className="btn btn-secondary"
            onClick={handleCloseAlert}
          >
            {t("Cancel")}
          </button>
          <button
            id={`ReportDisclaimerDeleteModalConfirm`}
            type="button"
            className="btn btn-danger m-2"
            onClick={() => DeleteReportDisclaimerById(item?.id)}
            disabled={disableDeletebutton}
          >
            <span>{check ? <LoaderIcon /> : null}</span>
            <span>
              {""} {t("Delete")}
            </span>
          </button>
        </BootstrapModal.Footer>
      </BootstrapModal>
    </>
  );
}
export default ReportDisclaimerRow;
